<template>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.75195 19.7202V18.1787C5.75195 15.9696 7.54281 14.1787 9.75195 14.1787H14.2477C16.4569 14.1787 18.2477 15.9696 18.2477 18.1787V19.4919" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        <ellipse cx="12" cy="7.65557" rx="3.37549" ry="3.3753" stroke="currentColor" stroke-width="1.5"/>
    </svg>
</template>
